let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iWQjq")).then(() => parcelRequire('8dtnj'));